exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Flyout .RibbonOverflowFlyout .RibbonItem{width:100%}.Flyout .RibbonOverflowFlyout .RibbonItem .Button{justify-content:left}.Flyout .RibbonOverflowFlyout .RibbonItem .Button:hover{background-color:transparent}", ""]);

// exports
